import React from 'react'
import { Link } from 'react-router-dom'

function Terms() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50 dark:from-gray-950 dark:via-gray-900 dark:to-gray-950">
      <div className="max-w-4xl mx-auto px-4 py-16">
        {/* Header */}
        <div className="text-center mb-12 animate-fade-in">
          <h1 className="text-5xl font-bold mb-4 bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 dark:from-white dark:via-gray-100 dark:to-white bg-clip-text text-transparent tracking-tight">
            Terms of Service
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-400 font-light tracking-wide">
            Guidelines for using the AI Grading Agent
          </p>
        </div>

        <div className="space-y-6">
          <div className="premium-card p-8">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              Acceptance of Terms
            </h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              By accessing and using the AI Grading Agent, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the application.
            </p>
          </div>

          <div className="premium-card p-8">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              Use of the Application
            </h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
              The AI Grading Agent is intended for educational purposes only. You agree not to use the application for any illegal or unauthorized purpose, including but not limited to:
            </p>
            <ul className="space-y-2 text-gray-700 dark:text-gray-300">
              <li className="flex gap-3">
                <span className="text-primary font-bold">•</span>
                <p>Violating intellectual property rights</p>
              </li>
              <li className="flex gap-3">
                <span className="text-primary font-bold">•</span>
                <p>Distributing harmful or malicious content</p>
              </li>
              <li className="flex gap-3">
                <span className="text-primary font-bold">•</span>
                <p>Attempting to compromise system security</p>
              </li>
              <li className="flex gap-3">
                <span className="text-primary font-bold">•</span>
                <p>Using the service for commercial grading without proper licensing</p>
              </li>
            </ul>
          </div>

          <div className="premium-card p-8">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              Intellectual Property
            </h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              The AI Grading Agent and its content are protected by copyright and other intellectual property laws. You may not copy, modify, or distribute any part of the application without our prior written consent.
            </p>
          </div>

          <div className="premium-card p-8">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              Limitation of Liability
            </h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              The AI Grading Agent is provided "as is" without any warranties. We are not liable for any damages arising from your use of the application. The grading results are AI-generated suggestions and should be reviewed by qualified educators.
            </p>
          </div>

          <div className="premium-card p-8">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              Changes to Terms
            </h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-2">
              We reserve the right to modify these Terms of Service at any time. Your continued use of the application after any changes indicates your acceptance of the new terms.
            </p>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              Effective date: {new Date().toLocaleDateString()}
            </p>
          </div>
        </div>

        {/* Back Button */}
        <div className="mt-12 text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 text-gray-700 dark:text-gray-300 hover:text-primary dark:hover:text-primary-light font-medium transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back to App
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Terms
